var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content__wrapper"},[(_vm.model.children.length)?_c('folder-header',{attrs:{"folder":_vm.model}}):_vm._e(),_c('div',{staticClass:"content"},_vm._l((_vm.model.children),function(item){return _c('div',{key:item.label},[_c('module-card',{attrs:{"module":item}})],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }